module.exports = __webpack_public_path__ + "media/images/logos/editionblau-logo-a25d737971b740f44ef05d6460362555.svg";